import { useCallback, useEffect, useState, Fragment } from "react";
import LoadingCM from "components/shared/Loading";
import {
  StyledCardContent,
  StyledTypographyContent,
  StyledImage,
  StyledLink,
  StyledImgContainer,
  StyledSlider,
} from "./About.style";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import useHttp from "hooks/use-http";
import {
  getAboutRequest,
  getGalleryRequest,
  getCertificateRequest,
} from "api/requests";
import Container from "@mui/material/Container";
import MenuCM from "components/shared/menu";
import { Grid } from "@mui/material";
import Alert from "@mui/material/Alert";
import FooterCM from "components/shared/footer";
import ContactCM from "components/contactus";
import parse from "html-react-parser";
import { Helmet } from "react-helmet";
import { IMG_BASE_URL } from "constants";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <ArrowBackIosIcon
      className={className}
      style={{ ...style, display: "block", color: "#009AC2" }}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <ArrowForwardIosIcon
      className={className}
      style={{ ...style, display: "block", color: "#009AC2" }}
      onClick={onClick}
    />
  );
}

export default function About() {
  const { request, loading } = useHttp();
  const [text, setText] = useState("");
  const [image, setImage] = useState({
    gallaryData: [],
    galleryCount: 0,
    certificateData: [],
    certificateCount: 0,
  });

  const getContent = useCallback(async () => {
    const resGallary = await request({
      url: getGalleryRequest,
      isMulty: true,
    });

    const resCertificate = await request({
      url: getCertificateRequest,
      isMulty: true,
    });

    let res = await request({
      url: getAboutRequest,
    });
    setText(res);

    if (resGallary && resCertificate) {
      let transformedDataGallery = resGallary.data.map((items) => ({
        id: items.id,
        image: items.image,
      }));

      let transformedDataCertificate = resCertificate.data.map((items) => ({
        id: items.id,
        image: items.image,
      }));

      setImage({
        gallaryData: transformedDataGallery,
        galleryCount: resGallary.count,
        certificateData: transformedDataCertificate,
        certificateCount: resCertificate.count,
      });
    }
  }, [request]);

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  useEffect(() => {
    getContent();
  }, [getContent]);

  return (
    <div>
      <Helmet>
        <title>درباره ما - مبلمان ویول</title>
        <meta name="product_id" content={""} />
        <meta name="product_name" content={""} />
        <meta name="product_price" content={""} />
        <meta name="product_old_price" content={""} />
        <meta name="availability" content={""} />
        <meta property="og:image" content={""} />
      </Helmet>
      {loading ? (
        <LoadingCM />
      ) : (
        <Fragment>
          <MenuCM pageTitle="درباره ما" />
          <Container>
            <Card
              sx={{
                marginTop: "30px",
                marginBottom: "30px",
                borderRadius: "15px",
              }}
            >
              <StyledCardContent>
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: "21px",
                  }}
                >
                  درباره ما
                </Typography>
              </StyledCardContent>

              <CardContent>
                <StyledTypographyContent
                  variant="body2"
                  color="text.secondary"
                  sx={{ textAlign: "justify" }}
                >
                  {text && parse(text?.text)}
                </StyledTypographyContent>
              </CardContent>
            </Card>
            {image?.galleryCount == 0 ? (
              ""
            ) : (
              <Card
                sx={{
                  marginTop: "30px",
                  marginBottom: "30px",
                  borderRadius: "15px",
                }}
              >
                <StyledCardContent>
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: "21px",
                    }}
                  >
                    گالری تصاویر
                  </Typography>
                </StyledCardContent>

                <CardContent>
                  <div style={{ padding: "20px" }}>
                    <StyledSlider {...settings}>
                      {image?.gallaryData.map((row, index) => {
                        return (
                          <StyledImgContainer key={"slider" + index}>
                            <Zoom>
                              <StyledImage
                                component="img"
                                src={IMG_BASE_URL + row.image}
                                alt="gallary"
                              />
                            </Zoom>
                          </StyledImgContainer>
                        );
                      })}
                    </StyledSlider>
                  </div>
                </CardContent>
              </Card>
            )}
            {image?.certificateCount == 0 ? (
              ""
            ) : (
              <Card
                sx={{
                  marginTop: "30px",
                  marginBottom: "30px",
                  borderRadius: "15px",
                }}
              >
                <StyledCardContent>
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: "21px",
                    }}
                  >
                    گواهینامه ها
                  </Typography>
                </StyledCardContent>

                <CardContent>
                  <div style={{ padding: "20px" }}>
                    <StyledSlider {...settings}>
                      {image?.certificateData.map((row, index) => {
                        return (
                          <StyledImgContainer key={"slider" + index}>
                            <Zoom>
                              <StyledImage
                                component="img"
                                src={IMG_BASE_URL + row.image}
                                alt="gallary"
                              />
                            </Zoom>
                          </StyledImgContainer>
                        );
                      })}
                    </StyledSlider>
                  </div>
                </CardContent>
              </Card>
            )}
            <Alert
              severity="info"
              sx={{ marginBottom: "30px", marginTop: "30px" }}
            >
              برای برقراری ارتباط با مدیران شرکت تولیدی نگين کاج شمال روی لینک
              مقابل کلیک کنید.
              <StyledLink to="/contact">ارتباط با ما</StyledLink>
            </Alert>
          </Container>
          <ContactCM All />
          <FooterCM />
        </Fragment>
      )}
    </div>
  );
}
